import {onMounted, reactive, watch, toRaw, ref} from "vue"
import Api from "@/modules/post/components/filter/services/Api"
import Image from "@/services/Image"
import DT from "@/services/DT"

export function useFilter(props, {emit}){
    const resetBootData = (val) => {
        bootData.search = val.search ?? '';
        bootData.search_full_match = val.search_full_match ?? false;
        bootData.date = val.date ?? null;
        bootData.users = val.users ?? [];
        bootData.typesCommerce = val.typesCommerce ?? [];
        bootData.shops = val.shops ?? [];
        bootData.categories = val.categories ?? [];
        bootData.type_visibility = val.type_visibility ?? 0;
        bootData.is_moderate = val.is_moderate ?? null;
        bootData.statuses = {
            published: val.statuses?.published ?? true,
            scheduled: val.statuses?.scheduled ?? true,
            removed: val.statuses?.removed ?? false,
            draft: val.statuses?.draft ?? false,
        };
        bootData.type_id = val.type_id ?? [];
        bootData.promocode = val.promocode ?? ""
    };

    let shopOptions = ref(false)

    let readyComponent = ref(false)

    let bootData = reactive({})

    const variantsData = reactive({
        users: [],
        typesCommerce: [],
    })

    const events = {
        applyDate: () => {
            onFilter()
        },
        onUser: (value) => {
            // тут приходится подменять вручную, а не использовать v-model
            // так как v-model реагирует перед событием и не учитывает текущий выбор
            // и наполняется предыдущим набором данных
            bootData.users = value
            onFilter()
        },
        onTypesCommerce: (value) => {
            // тут приходится подменять вручную, а не использовать v-model
            // так как v-model реагирует перед событием и не учитывает текущий выбор
            // и наполняется предыдущим набором данных
            bootData.typesCommerce = value
            onFilter()
        },
        onSearch: () => {
            onFilter()
        },
        onStatuses: () => {
            onFilter()
        },
        onShops: (value) => {
            bootData.shops = value
            onFilter()
        },
        onCategories: (value) => {
            bootData.categories = value
            onFilter()
        },
        onTypeVisible: (value) => {
            bootData.type_visibility = value
            onFilter()
        },
        onIsModerate: (value) => {
            bootData.is_moderate = value
            onFilter()
        },
        onTypeId: (value) => {
            bootData.type_id = value
            onFilter()
        },
        onPromocode: (value) => {
            bootData.promocode = value
            onFilter()
        },
    }

    watch(() => props.params, (val) => {
        resetBootData(toRaw(val))
        onFilter()
    })

    onMounted(() => {
        resetBootData(props.params)
        users()
        typesCommerce()
        onFilter(true)
        setReadyComponent(true)
    })

    function setReadyComponent(val) {
        readyComponent.value = val
    }

    function isReadyComponent() {
        return readyComponent.value === true
    }

    function users() {
        return Api.users().then((resp) => {
            usersMultiSelect(resp)
        })
    }

    function typesCommerce() {
        let variants = [];

        for (let i = 1; i <= 8; i++) {
            variants.push(
                {
                    "id": i,
                    "name": "Тип-" + i,
                }
            )
        }

        variants.push(
            {
                "id": 9,
                "name": "Без оплаты",
            }
        )

        typesCommerceMultiSelect(variants)
    }

    function onFilter(auto) {
        auto = auto === true

        if (auto === false) {
            const url = new URL(window.location.href);
            url.searchParams.set("filter", "1");
            window.history.pushState({}, '', url);
        }

        pushParent(auto)
    }

    function usersMultiSelect(items) {
        for (let prop in items) {
            let obj = items[prop]
            let image = ""

            if (obj["avatar_host"] && obj["avatar_name"]) {
                image = Image.handle(obj["avatar_host"], obj["avatar_name"], 60)
            } else {
                image = "/assets/static/user/no_image.jpg"
            }
            variantsData.users.push({
                value: obj["id"],
                name: obj["name"],
                image: image,
            })
        }
    }

    function typesCommerceMultiSelect(items) {
        for (let prop in items) {
            let obj = items[prop]

            variantsData.typesCommerce.push({
                value: obj["id"],
                name: obj["name"],
            })
        }
    }

    function pushParent(auto) {
        emit("onFilter", getResult(auto))
    }

    function getResult(auto) {
        let date = forDateResult(bootData.date)

        return {
            auto: auto,
            search: bootData.search,
            search_full_match: bootData.search_full_match,
            date: {
                from: date[0],
                to: date[1],
            },
            users: bootData.users,
            types_commerce: bootData.typesCommerce,
            statuses: {
                published: bootData.statuses.published,
                scheduled: bootData.statuses.scheduled,
                removed: bootData.statuses.removed,
                draft: bootData.statuses.draft,
            },
            shops: bootData.shops,
            categories: bootData.categories,
            type_visibility: bootData.type_visibility,
            is_moderate: bootData.is_moderate,
            type_id: bootData.type_id,
            promocode: bootData.promocode,
        }
    }

    function forDateResult(date) {
        if (date === null) {
            return [
                null,
                null,
            ]
        }

        let from = new DT(date[0]).startTimeOfDay()
        let to = new DT(date[1]).endTimeOfDay()

        from.setMonth(from.getMonthNatural())
        to.setMonth(to.getMonthNatural())

        return [
            from.get("%Y-%M-%D %H:%I:%S"),
            to.get("%Y-%M-%D %H:%I:%S"),
        ]
    }

    function isEnable() {
        return props.enable === true
    }

    function showOptions() {
        shopOptions.value = !shopOptions.value
    }

    function isShowOptions() {
        return shopOptions.value
    }

    return {
        events,
        bootData,
        variantsData,
        isEnable,
        isReadyComponent,
        showOptions,
        isShowOptions,
    }
}
